import ENDPOINTS from "@app/constants/endpoints"
import { fetchWithValidation } from "@app/helpers/fetchWithValidation"
import { useQuery } from "@tanstack/react-query"
import { DashboardSchema, type DashboardData } from "../models/dashboard"

export const useDashboard = () => {
  return useQuery<DashboardData, Error>({
    queryKey: ["dashboard"],
    queryFn: () => fetchWithValidation(ENDPOINTS.DASHBOARD, DashboardSchema),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 60,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}

export default useDashboard